import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { PLAY_STORE_URL } from "@/config";

const NAV_LINKS = [
  { label: "How it works", href: "/#how-it-works", testId: "nav-how-it-works" },
  { label: "Features", href: "/#features", testId: "nav-features" },
  { label: "Pricing", href: "/#pricing", testId: "nav-pricing" },
  { label: "FAQ", href: "/#faq", testId: "nav-faq" },
  { label: "Blog", href: "/blog", testId: "nav-blog", route: true },
  { label: "Support", href: "/support", testId: "nav-support", route: true },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const renderLink = (link, mobile = false) => {
    const cls = mobile
      ? "block px-2 py-3 font-display text-lg font-semibold uppercase tracking-wider text-onsurface2 transition-colors hover:text-onsurface"
      : "font-display text-sm font-semibold uppercase tracking-wider text-onsurface2 transition-colors hover:text-onsurface";
    return link.route ? (
      <Link key={link.testId} data-testid={link.testId} to={link.href} className={cls} onClick={() => setOpen(false)}>
        {link.label}
      </Link>
    ) : (
      <a key={link.testId} data-testid={link.testId} href={link.href} className={cls} onClick={() => setOpen(false)}>
        {link.label}
      </a>
    );
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-divider bg-surface/80 backdrop-blur-xl">
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6" aria-label="Main navigation">
        <Link to="/" data-testid="nav-logo" className="font-display text-xl font-bold uppercase tracking-[1.5px] text-onsurface">
          Sell<span className="text-brand-light">craft</span>
        </Link>

        <div className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map((l) => renderLink(l))}
        </div>

        <div className="hidden lg:block">
          <a
            data-testid="nav-get-app-btn"
            href={PLAY_STORE_URL}
            className="inline-flex items-center rounded-lg bg-brand px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-white shadow-cta transition-shadow duration-200 hover:shadow-cta-lg"
          >
            Get the app
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="rounded-md p-2 text-onsurface lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-divider bg-surface px-6 pb-6 pt-2 lg:hidden">
          {NAV_LINKS.map((l) => renderLink(l, true))}
          <a
            data-testid="nav-mobile-get-app-btn"
            href={PLAY_STORE_URL}
            className="mt-4 block rounded-lg bg-brand px-5 py-3 text-center font-display text-sm font-bold uppercase tracking-wider text-white shadow-cta"
          >
            Get the app
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
